import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#C7D0D9" d="M93.5 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M78.05.94a1.5 1.5 0 0 1 0 2.12l-9.99 9.99a1.5 1.5 0 0 1-2.12-2.12L75.93.94a1.5 1.5 0 0 1 2.12 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M65.94.94a1.5 1.5 0 0 1 2.12 0l9.99 9.99a1.5 1.5 0 0 1-2.12 2.12l-9.99-9.99a1.5 1.5 0 0 1 0-2.12"
      clipRule="evenodd"
    />
    <path fill="#C7D0D9" d="M107.5 40a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M9.57 61.5a1.5 1.5 0 0 1 1.5 1.5v14.13a1.5 1.5 0 1 1-3 0V63a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M1 70.07a1.5 1.5 0 0 1 1.5-1.5h14.13a1.5 1.5 0 0 1 0 3H2.5a1.5 1.5 0 0 1-1.5-1.5M20 89a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M25.504 17C22.468 17 20 19.45 20 22.488v35.644c0 17.599 26.523 37.172 35.54 42.995a5.46 5.46 0 0 0 5.92 0C70.477 95.314 97 75.731 97 58.132V22.488a5.46 5.46 0 0 0-1.615-3.878A5.5 5.5 0 0 0 91.497 17z"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M50.25 37.358V51.75h15.5V37.358a.1.1 0 0 0-.028-.035.3.3 0 0 0-.202-.073H50.48a.3.3 0 0 0-.202.073.1.1 0 0 0-.028.035m-4.5-.002c0-2.648 2.231-4.606 4.73-4.606h15.04c2.499 0 4.73 1.958 4.73 4.606V56.25h-24.5z"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M70.659 49H45.34C44.048 49 43 50.06 43 51.367v21.266C43 73.94 44.048 75 45.341 75H70.66C71.952 75 73 73.94 73 72.633V51.367C73 50.06 71.952 49 70.659 49"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M56.241 61.047a2 2 0 1 0 3.517 1.907 2 2 0 0 0-3.517-1.907M64 62a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconSafeGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSafeGreyscale);
export default Memo;
